import angular from 'angular';
import template from './template.html';
import { CandidatesList, CandidatesListConfiguration } from '../candidates-list/index';
import './style.scss';

export const CANDIDATE_ITEM_HEIGHT = 333;

export class CandidatesListInfinity extends CandidatesList {
    virtualScrollOptions = {
        scrollParent: 'window',
        size: CANDIDATE_ITEM_HEIGHT,
        scrollMargin: CANDIDATE_ITEM_HEIGHT * 2,
    };

    fetchMore() {
        const { pageOptions, canFetchMore, isLoading } = this;

        if (!canFetchMore || isLoading) {
            return;
        }

        this.onFetchMore({
            pageOptions: {
                ...pageOptions,
                page: pageOptions.page + 1,
            },
        });
    }
}

export const CandidatesListInfinityConfiguration = {
    ...CandidatesListConfiguration,
    template,
    bindings: {
        ...CandidatesListConfiguration.bindings,
        isLoading: '<',
        mode: '@',
        canFetchMore: '<',
        listType: '<',
        pageOptions: '<',
        feedbackFilterMode: '<',
        candidatePageRoute: '<',
        currentWorkflow: '<',
        currentRecruiter: '<',
        onFetchMore: '&',
    },
    controller: CandidatesListInfinity,
    controllerAs: 'candidatesListInfinityCtrl',
};

angular.module('TALENYA-FE').component('candidatesListInfinity', CandidatesListInfinityConfiguration);
